module.exports = __webpack_public_path__ + "img/shareBg.b8593acc.png";